import { Component, OnInit,Input,ViewChild, ElementRef } from '@angular/core';
import { GfichierService } from '../../service/gfichier.service';

@Component({
  selector: 'app-editable',
  templateUrl: './editable.component.html',
  styleUrls: ['./editable.component.scss'],
})
export class EditableComponent implements OnInit {

  @Input() content: string;
  @Input() id: number;

  @ViewChild('idtexte', {static: true}) idtexte : ElementRef;
  
  constructor(public gfichier : GfichierService) { }

  ngOnInit() {}

  ngOnChanges() {
    
    this.idtexte.nativeElement.innerHTML = this.content;


  }

  aChanger() {
   // alert(this.idtexte.nativeElement.innerHTML);
    this.gfichier.setValue(this.idtexte.nativeElement.innerHTML,this.id,"edit");
  
  }



}
